import styled from "styled-components";
import media from "styled-media-query";

export const MainGrid = styled.section`
  display: grid;
  grid-template-rows: ${({ noHeader }) => (noHeader ? "auto" : "60px 1fr")};
  background-color: ${({ theme }) => theme.colors.primary.BG};
  min-height: var(--app-height);

  ${media.greaterThan("medium")`
    align-items: baseline;
    justify-items: center;
    background-size: cover;
    grid-row-gap: 28px;
  `}
`;

export const TopLogoWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;

  ${media.greaterThan("medium")`
    align-items: end;
    justify-items: center;
  `}
`;

export const LogoImage = styled.img`
  width: 176px;
  cursor: pointer;
`;

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 24px 24px 0px 0px;
  padding: ${({ noPadding }) => !noPadding && "0 16px 16px 16px"};
  overflow: hidden;
  height: fit-content;
  align-self: end;

  ${media.greaterThan("medium")`
  align-self: center;
    max-width: 720px;
    border-radius: 24px;
    padding: ${({ noPadding }) => !noPadding && "0 32px 32px 32px"};
  `}
`;
